import React from 'react';
import { ProjectsContentPlayfulTeacher } from './ProjectsContent';
import { ProjectsProvider } from '../provider';

// Workspace do projeto no tema playful do professor: sem <Dashboard>/sidebar
// própria (o shell padrão já cuida disso), igual às outras telas do professor
// playful (GroupProjectDetailPlayfulTeacher.jsx). A variante do aluno continua
// em ../Playful/ProjectsView.jsx, a corporativa em ../Default/ProjectsView.jsx.
export default function ProjectsViewPlayfulTeacher({ projectId }) {
  return (
    <ProjectsProvider>
      <ProjectsContentPlayfulTeacher projectId={projectId} />
    </ProjectsProvider>
  );
}
